import ky from 'ky';
import * as Constants from '../constants';
import { showNotification } from '../features/notification';

export const api = ky.create({
  prefixUrl: Constants.API_URL,
  headers: {
    'x-referer-url': window.location.href,
    'x-requested-with': 'XMLHttpRequest',
  },
  mode: 'cors',
  credentials: 'include',
  retry: 1,
  throwHttpErrors: false,
});

export const DEFAULT_OPTIONS = {
  retry: 0,
};
interface IApiResponse {
  response: any;
  error: any;
}
export const ApiResponse = async (res: any): Promise<IApiResponse> => {
  const data = await res.json();
  if (res.ok) {
    return { response: data, error: null } as IApiResponse;
  }
  if (res.status === 401 && data.redirect_url) {
    window.location.href = data.redirect_url;
    return {} as IApiResponse;
  }
  const error =
    res.status === 401 // Don't throw errors for 401
      ? null
      : (new Error(
          data.message || 'There was a problem with your request.'
        ) as any);
  error.internal = process.env.NODE_ENV !== 'production';
  return { error, response: null } as IApiResponse;
};

export const throwError = (
  err: any,
  safeMessage = 'There was a problem with your request.'
): any => {
  /* showNotification({
    type: 'error',
    duration: 4000,
    title: 'Oh no! Something went wrong.',
    message: err.internal ? err.message : safeMessage,
  }); */
  throw new Error(err.internal ? err.message : safeMessage);
};
